// Central API configuration
// All backend calls in the app must reference this constant
// instead of hardcoding the URL in each component.
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost/backend';

// Use this for constructing image/media URLs served from the root domain.
export const API_IMAGE_BASE_URL = process.env.REACT_APP_API_IMAGE_BASE_URL || 'https://ethiccraft.org';

export default API_BASE_URL;
